import WeezSocket, { NullSocket } from '../common/weezSocket';

let socket = null;

if(window.self === window.top) {
    socket = new NullSocket();
} else {
    // Iframe mode!
    socket = new WeezSocket(window.self);
}

export default socket;
